<i *ngIf="source && icon"
   class="{{ icon }} source-icon source-icon-{{ source }}"
   tooltip="{{ label | translate }}"
   container="body"
   placement="top"></i>
